<template>
  <div>

    <!-- Warning if cancer register is not found -->

    <div class="flex-gt-sm-100 flex-100 mx-2 mb-4">
      <div style="border:1px solid;border-radius: 9px;"
           class="pa-3"
           :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}"
           v-if="!userCancerRegister"
      >
        <v-icon class="mr-3" size="30" :color="'#E53935'">mdi-alert</v-icon>
        <span v-if="userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('WARNING_MISSING_CANCER_REGISTER') }}</small></span>
        <span v-if="!userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('WARNING_MISSING_CANCER_REGISTER_EMPLOYEE') }}</small></span>

        <v-btn :color="'#E53935'"
               v-if="userIsPhysician"
               dark
               depressed
               class="text-none ml-4"
               style="height: 28px;"
               @click="openAccountTab()"
        >{{ $t('WARNING_MISSING_CANCER_REGISTER_BTN_TEXT') }}</v-btn>
      </div>
    </div>

    <div class="flex-gt-sm-100 flex-100 layout-row layout-wrap">

      <!-- Primärtumor Diagnosedatum -->

      <div class="flex-gt-sm-25 flex-100 px-2 mb-4">
        <validation-provider tag="div"
                             name="diagnose.diagnosedatum"
                             ref="diagnose.diagnosedatum"
                             rules="required|german_date|date_not_in_future"
                             v-slot="{ errors }">
          <lx-datepicker
            :color="compColor.textInput"
            name="diagnose.diagnosedatum"
            @input="setDateAccuracyAfterDate"
            :label="$t('FORMS_DIVERSE.ICD_CODE_DATE') + ' *'"
            :dense="denseFields"
            :hide-details="!errors || errors.length <= 0"
            :error="errors[0]"
            v-model="model.diagnosedatum"
          ></lx-datepicker>
        </validation-provider>
      </div>

      <!-- Primärtumor Datumsgenauigkeit Diagnosedatum -->

      <div class="flex-gt-sm-25 flex-100 px-2">
        <div class="layout-row">
          <validation-provider tag="div"
                               class="flex"
                               name="diagnose.diagnosedatum_genauigkeit"
                               ref="diagnose.diagnosedatum_genauigkeit"
                               rules="required"
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              :label="$t('FORMS_DIVERSE.ICD_CODE_DATE_ACCURACY') + ' *'"
              v-model="model.diagnosedatum_genauigkeit"
              :items="DateAccuracyTypes"
              :disabled="isDisabled"
              outlined
              @change="validateDateAfterChangeOfAccuracy()"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>

          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                   :class="{'mt-1': !denseFields}"
                   style="cursor: pointer;">
                <v-icon :color="compColor.prime" medium>info</v-icon>
              </div>
            </template>
            <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
          </v-tooltip>
        </div>
      </div>

      <div class="flex-gt-sm-50 flex-100 px-2"></div>
    </div>

    <div class="flex-gt-sm-100 flex-100 px-2 mb-2"></div>

    <!-- Primärtumor ICD10-Code -->

    <div class="flex-gt-sm-25 flex-100 px-2 mb-2">
      <validation-provider tag="div"
                           name="diagnose.primaertumor_icd_code"
                           ref="diagnose.primaertumor_icd_code"
                           rules="required|icd10_code_auto_complete"
                           v-slot="{ errors }">
        <lx-autocomplete
            :label="$t('FORMS_DIVERSE.ICD_CODE') + ' *'"
            v-model="model.primaertumor_icd_code"
            :error="errors[0]"
            @search-method="getDataForAutocomplete"
            @input="setDiagnosis"
            :disabled="isDisabled"
            :dense="denseFields"
            :hint="$t('FORMS_DIVERSE.CANCER_DIAGNOSIS_HINT')"
            :persistent_hint="true"
            :results="resultSearchModel">
          <template v-slot="slotProps">
            <div class="layout-row">
              <div style="width: 100px;border-radius: 4px;" class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                <h3>
                  <lx-text-highlight :text="slotProps.lineItem.code" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                </h3>
              </div>
              <div class="flex">
                <span class="body-2">
                  <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                </span>
              </div>
            </div>
          </template>
        </lx-autocomplete>
      </validation-provider>
    </div>

    <!-- Primärtumor ICD-Version -->

    <div class="flex-gt-sm-25 flex-100 px-2">
      <validation-provider tag="div"
                           name="diagnose.primaertumor_icd_version"
                           ref="diagnose.primaertumor_icd_version"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.ICD_CODE_VERSION') + ' *'"
          v-model="model.primaertumor_icd_version"
          :items="Primaertumor_ICD_VersionTypes"
          outlined
          :dense="denseFields"
          @change="resetICD10Code()"
          :persistent-hint="true"
          :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Primärtumor Diagnosetext -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           name="diagnose.primaertumor_diagnosetext"
                           ref="diagnose.primaertumor_diagnosetext"
                           rules=""
                           v-slot="{ errors }">
        <v-text-field
          :label="$t('FORMS_DIVERSE.ICD_CODE_TEXT')"
          :color="compColor.primeColor"
          :dark="compColor.isInDarkMode"
          v-model="model.primaertumor_diagnosetext"
          disabled
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          outlined
          :error-messages="errors[0]"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-100 flex-100 px-2"></div>

    <!-- Primärtumor ICD-O-Code -->

    <div class="flex-gt-sm-25 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.primaertumor_topographie_icd_o'"
                           :ref="path + '.primaertumor_topographie_icd_o'"
                           rules="required|icd_o_code_auto_complete"
                           v-slot="{ errors }">
        <lx-autocomplete
          :label="$t('FORMS_DIVERSE.ICD_O_CODE') + ' *'"
          v-model="model.primaertumor_topographie_icd_o"
          :error="errors[0]"
          @search-method="getICDOForAutocomplete"
          @input="setICDODiagnosis"
          :disabled="isDisabled"
          :dense="denseFields"
          :results="resultSearchICDOModel">
          <template v-slot="slotProps">
            <div class="layout-row">
              <div style="width: 100px;border-radius: 4px;"
                   class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                <h3>
                  <lx-text-highlight :text="slotProps.lineItem.code"
                                     :search-string="slotProps.searchText"
                                     :color="compColor.prime"></lx-text-highlight>
                </h3>
              </div>
              <div class="flex">
                    <span class="body-2">
                      <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText"
                                         :color="compColor.prime"></lx-text-highlight>
                    </span>
              </div>
            </div>
          </template>
        </lx-autocomplete>
      </validation-provider>
    </div>

    <!-- Primärtumor IC-O-Version -->

    <div class="flex-gt-sm-25 flex-100 px-2">
      <validation-provider tag="div"
                           name="diagnose.primaertumor_topographie_icd_o_version"
                           ref="diagnose.primaertumor_topographie_icd_o_version"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.ICD_O_VERSION') + ' *'"
          v-model="model.primaertumor_topographie_icd_o_version"
          :items="Primaertumor_ICD_O_VersionTypes"
          outlined
          :dense="denseFields"
          @change="resetICDOCode()"
          :persistent-hint="true"
          :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Primärtumor IC-O-Text -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           name="diagnose.primaertumor_topographie_icd_freitext"
                           ref="diagnose.primaertumor_topographie_icd_freitext"
                           rules=""
                           v-slot="{ errors }">
        <v-text-field
            :label="$t('FORMS_DIVERSE.ICD_O_CODE_TEXT')"
            :name="path + '.primaertumor_topographie_icd_freitext'"
            :color="compColor.primeColor"
            :dark="compColor.isInDarkMode"
            v-model="model.primaertumor_topographie_icd_freitext"
            disabled
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            outlined
            :error-messages="errors[0]"
        ></v-text-field>
      </validation-provider>
    </div>

    <!-- switch report or ignore for report new diagnosis -->

    <div class="flex-gt-sm-100 flex-100 layout-row px-2 mb-2">
      <label :style="{color: compColor.primeColor}" class="pt-2 mr-3 ml-1">{{ $t('FORMS_DIVERSE.MODULE_DIAGNOSIS_SWITCH_NEW_DIAGNOSIS') }}</label>
      <v-btn-toggle v-model="setReportValue"
                    dense
                    class="ml-6"
                    :mandatory="setReportValue!== undefined && setReportValue!=null"
                    style="margin-top:2px; background-color: transparent;"
                    :color="compColor.prime">
        <v-btn :key="index" v-for="(kind, index) in listBtnGroupReportDiagnosis" :value="kind.value">
          {{ kind.text }}
        </v-btn>
      </v-btn-toggle>

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-center px-2 ml-3"
               style="cursor: pointer;">
            <v-icon :color="compColor.prime" medium>info</v-icon>
          </div>
        </template>
        <p style="max-width: 480px;" class="ma-2">{{ $t('FORMS_DIVERSE.MODULE_DIAGNOSIS_TOOLTIP_NEW_DIAGNOSIS') }}</p>
      </v-tooltip>
    </div>

    <v-divider class="mb-2" v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

    <!-- Primärtumor Seitenlokalisation -->

    <div class="flex-100 px-2 py-3">
      <validation-provider tag="div"
                           name="diagnose.seitenlokalisation"
                           ref="diagnose.seitenlokalisation"
                           :rules="{required: !!isPairedPrimaryTumor(model.primaertumor_icd_code)}"
                           v-slot="{ errors }">
        <fake-input-frame :label="isPairedPrimaryTumor(model.primaertumor_icd_code) ? $t('FORMS_DIVERSE.ICD_CODE_SIDE_LOCALIZATION_PAIRED_TUMOR') + ' *' : $t('FORMS_DIVERSE.ICD_CODE_SIDE_LOCALIZATION')"
                          :errors="errors.length > 0">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group v-model="model.seitenlokalisation"
                           :dense="denseFields"
                           :error-messages="errors[0]"
                           hide-details
                           class="ma-0 pa-0"
                           style="flex:unset;margin-top: 10px;">
              <v-radio v-for="(value, key) in getSideLocalizationTypes(model.primaertumor_icd_code)"
                       :label="value"
                       :value="key"
                       :key="key"
                       :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                       class="mb-1"
                       :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>

            <!-- Reset value of seitenlokalisation via button  -->

            <v-btn :color="compColor.primeColor"
                   :dark="compColor.isInDarkMode"
                   depressed
                   text
                   width="auto"
                   class="white--text text-none layout-row layout-align-start-center ml-n2 px-2 mt-1"
                   @click="$set(model, 'seitenlokalisation', null)"
                   v-show="model.seitenlokalisation && !isPairedPrimaryTumor(model.primaertumor_icd_code)"
                   :disabled="!model.seitenlokalisation"
                   :title="$t('buttons.deleteSelection.title')">
              <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                      size="24">mdi-arrow-up-bold
              </v-icon>
              <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
            </v-btn>
          </div>
        </fake-input-frame>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import metaData from '../../components/documentation/shared/formsMetaData'
import utils from '../../common/utils'
import LxAutocomplete from '../../components/lx_auto_complete/LxAutocomplete'
import LxTextHighlight from '../../components/lx_text_highlighter/LxTextHighlight'
import moment from 'moment'

export default {
  name: 'Diagnose',
  mixins: [metaData, utils],
  components: {
    LxAutocomplete,
    LxTextHighlight
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    reportNewDiagnosis: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {},
      setReportValue: false,
      resultICDModel: {},
      resultSearchModel: {},
      resultSearchICDOModel: {},
      DiagnosesicherungTypes: null,
      SeitenlokalisationTypes: null,
      Primaertumor_ICD_VersionTypes: null,
      Primaertumor_ICD_O_VersionTypes: null,
      PairedTumorList: [],
      PairedAdditionalTumors: {},
      DateAccuracyTypes: null,
      listBtnGroupReportDiagnosis: [
        { value: true, text: this.$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES') },
        { value: false, text: this.$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO') }
      ]
    }
  },
  created () {
    this.DiagnosesicherungTypes = this.formsMetaData.DiagnosesicherungTypes
    this.SeitenlokalisationTypes = this.formsMetaData.SeitenlokalisationTypes
    this.SeitenlokalisationTypesPairedTumors = this.formsMetaData.SeitenlokalisationTypesPairedTumors
    this.Primaertumor_ICD_VersionTypes = this.filterVersions('icd10')
    this.Primaertumor_ICD_O_VersionTypes = this.filterVersions('icdO')
    this.PairedTumorList = this.formsMetaData.PairedTumorList
    this.PairedAdditionalTumors = this.formsMetaData.PairedAdditionalTumors
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyLong
  },
  methods: {
    /**
     * Set date accuracy per default after date input
     */
    setDateAccuracyAfterDate () {
      // set diagnosedatum_genauigkeit if not exists after changing diagnosedatum in datepicker
      if (this.model.diagnosedatum && !this.model.diagnosedatum_genauigkeit) {
        this.model.diagnosedatum_genauigkeit = 'E'
      }


      // set version in dependency to date, if not exists
      if (moment(this.model.diagnosedatum, ['DD.MM.YYYY', 'DD.MM.YY', moment.ISO_8601]).isValid()) {
        const dateYear = new Date(this.model.diagnosedatum).getFullYear()
        const selectedVersion = this.Primaertumor_ICD_VersionTypes.find((code) => { return code.misdValue === dateYear.toString() })

        // version will only be set, if year is part of version-list, else set it on "Sonstige"
        if (selectedVersion) {
          this.$set(this.model, 'primaertumor_icd_version', selectedVersion.value)
        } else {
          this.$set(this.model, 'primaertumor_icd_version', this.Primaertumor_ICD_VersionTypes[this.Primaertumor_ICD_VersionTypes.length - 1].value)
        }
      }
    },

    /**
     * Delete ICD10-code, text and localization after changing version
     */
    resetICD10Code () {
      this.$delete(this.model, 'primaertumor_icd_code')
      this.$delete(this.model, 'primaertumor_diagnosetext')
      this.$delete(this.model, 'seitenlokalisation')
    },

    /**
     * Delete ICDO-code and text after changing ICD-O-version
     */
    resetICDOCode () {
      this.$delete(this.model, 'primaertumor_topographie_icd_o')
      this.$delete(this.model, 'primaertumor_topographie_icd_freitext')
    },

    /**
     * Validate date after changing date accuracy
     */
    validateDateAfterChangeOfAccuracy () {
      this.$nextTick(() => {
        if (this.$refs['diagnose.diagnosedatum']) {
          this.$refs['diagnose.diagnosedatum'].validate()
        }
      })
    },

    /**
     * Open tab of physician-account to edit cancer register details
     */
    openAccountTab () {
      this.addTabToStore({
        routeName: 'AccountDetails',
        options: {
          headline: 'Account',
          icon: 'mdi-account-circle'
        }
      })
    },

    /**
     *  Return true is primary tumor is paired tumor
     *
     * @param code The icd-10 code of primary tumor
     * @returns {boolean|*}
     */
    isPairedPrimaryTumor (code) {
      return this.PairedTumorList.indexOf(code) > -1 || this.PairedAdditionalTumors[code]
    },

    /**
     * Return list of side localizations in dependency to existing paired primary tumor
     *
     * @param code The icd-10 code of primary tumor
     */
    getSideLocalizationTypes (code) {
      return this.PairedTumorList.indexOf(code) > -1 || this.PairedAdditionalTumors[code] ? this.SeitenlokalisationTypesPairedTumors : this.SeitenlokalisationTypes
    },

    /**
     * Get list of icd10 codes via regex in auto-complete
     *
     * @param data The search string for diagnosis
     */
    getDataForAutocomplete (data) {
      if (data && this.model.primaertumor_icd_code && data !== this.model.primaertumor_icd_code) {
        this.$set(this.model, 'primaertumor_diagnosetext', undefined)
      }

      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 30
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.value === this.model.primaertumor_icd_version)

      if (foundVersion?.misdValue) {
        config.query.version = foundVersion.misdValue
      }

      // if selected version is "Sonstige", then use oldest misd-version for request
      if (foundVersion?.value === 'Sonstige') {
        config.query.version = this.Primaertumor_ICD_VersionTypes[this.Primaertumor_ICD_VersionTypes.length - 2].misdValue
      }

      this.$http.get('/icd10?config=' + JSON.stringify(config) + '&filtered=tumor')
          .then(res => {
            this.resultSearchModel = {
              result: res.data.items,
              count: res.data.count,
              version: foundVersion?.value === 'Sonstige' ? 'Sonstige' : res.data.version
            }
          })
          .catch(this.NotifyError)
    },

    /**
     * Set icd10 value via list form auto complete
     *
     * @param data The object from list of founded diagnoses
     */
    setDiagnosis (data) {
      this.$set(this.model, 'seitenlokalisation', null)

      if (data && data.code) {
        const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.misdValue === this.resultSearchModel.version)
        const version = foundVersion?.value ? foundVersion?.value : this.formsMetaData.ICD10_Version

        this.$set(this.model, 'primaertumor_icd_code', data.code)
        this.$set(this.model, 'primaertumor_diagnosetext', data.description)
        this.$set(this.model, 'primaertumor_icd_version', version)

        if (!this.model.diagnosesicherung) {
          this.$set(this.model, 'diagnosesicherung', '7.1')
        }

        // set side localization of non-paired tumor on "Trifft nicht zu"
        if (!this.isPairedPrimaryTumor(data.code)) {
          this.$set(this.model, 'seitenlokalisation', 'T')
        }

        this.setICDOAfterICD10(data, this.model.primaertumor_topographie_icd_o_version)
      } else {
        if (!this.model.primaertumor_icd_code || typeof data === 'string' || (this.validationRef.errors && this.validationRef.errors['diagnose.primaertumor_icd_code'] && this.validationRef.errors['diagnose.primaertumor_icd_code'].length > 0)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of icd10, if not selected from result list
            if (typeof data === 'string') this.$set(this.model, 'primaertumor_icd_code', null)
          })

          this.$set(this.model, 'primaertumor_diagnosetext', undefined)
          this.$set(this.model, 'primaertumor_topographie_icd_o', undefined)
          this.$set(this.model, 'primaertumor_topographie_icd_freitext', undefined)
        }
      }
    },

    /**
     * Get list of icdO codes via regex in auto-complete
     *
     * @param data The search string
     */
    getICDOForAutocomplete (data) {
      if (data && this.model.primaertumor_topographie_icd_o && data !== this.model.primaertumor_topographie_icd_o) {
        this.$set(this.model, 'primaertumor_topographie_icd_freitext', undefined)
      }

      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 30
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.Primaertumor_ICD_O_VersionTypes.find(elem => elem.value === this.model.primaertumor_topographie_icd_o_version)

      if (foundVersion?.misdValue) {
        config.query.version = foundVersion.misdValue
      }

      this.$http.get('/icdO?config=' + JSON.stringify(config))
        .then(res => {
          this.resultSearchICDOModel = {
            result: res.data.items,
            count: res.data.count || 0,
            version: res.data.version
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Set icd10 value via list form auto complete
     *
     * @param data The selected object from list of proposed icdO-codes
     */
    setICDODiagnosis (data) {
      if (data && data.code) {
        const foundVersion = this.Primaertumor_ICD_O_VersionTypes.find(elem => elem.misdValue === this.resultSearchICDOModel.version)
        const version = foundVersion?.value ? foundVersion?.value : this.formsMetaData.ICDO_Version

        this.$set(this.model, 'primaertumor_topographie_icd_o', data.code)
        this.$set(this.model, 'primaertumor_topographie_icd_freitext', data.description)
        this.$set(this.model, 'primaertumor_topographie_icd_o_version', version)
      } else {
        if (!this.model.primaertumor_topographie_icd_o || typeof data === 'string' || (this.validationRef.errors && this.validationRef.errors[this.path + '.primaertumor_topographie_icd_o'] && this.validationRef.errors[this.path + '.primaertumor_topographie_icd_o'].invalid)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of icdO, if not selected from result list
            if (typeof data === 'string') this.$set(this.model, 'primaertumor_topographie_icd_o', null)
          })

          this.$set(this.model, 'primaertumor_topographie_icd_freitext', undefined)
        }
      }
    }
  },
  computed: {
    userCancerRegister () {
      return this.getUserCancerRegisterDetails().register_id
    },
    userIsPhysician () {
      return this.authStore.getters.userIsPhysician
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    setReportValue: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input-ignore', newValue)
        }
      },
      immediate: true
    },
    reportNewDiagnosis: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setReportValue = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss">
  v-cloak { display: none }
</style>
